export default __webpack_public_path__ + "static/media/icon-arrow-down.abf04904.svg";